/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { AllasStandaloneMarkup as ResolvedStandaloneMarkup } from 'sites/allas/components/standalone/Markup';

export const Markup: typeof ResolvedStandaloneMarkup = withStandaloneInstanceof((props) => {
    return (
        <ResolvedStandaloneMarkup {...props} />
    );
});

export type MarkupProps = PropsFromComponent<typeof Markup>;

/** @deprecated Use slot architecture instead */
export const MarkupWith = (extras: DynamicStandaloneExtras): typeof Markup => {
    return function Markup(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Markup');
        return <ResolvedStandaloneMarkup {...mergeProps({ options: { theme } }, props)} />;
    }
}